module.exports = __webpack_public_path__ + "img/hootie@2x.714df57a.png";